// removed by extract-text-webpack-plugin
module.exports = {"EditPageOnSideMenu--menu":"EditPageOnSideMenu--menu","addPage":"addPage","EditPageOnSideMenu--pageList":"EditPageOnSideMenu--pageList","activePages":"activePages","EditPageOnSideMenu--page":"EditPageOnSideMenu--page","content":"content","editPage":"editPage","viewPage":"viewPage","active":"active"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Website/EditPageOnSideMenu/EditPageOnSideMenu.scss
// module id = lGU1
// module chunks = 0